class EventDispatcher
{

    /**
     * @param {Logger} logger
     */
    constructor(logger) {
        this._logger = logger;
        this._eventSubscribers = {};
    }

    on(event, callback, bindThis)
    {
        if (typeof bindThis !== 'undefined') {
            callback = callback.bind(bindThis);
        }
        if (typeof this._eventSubscribers[event] === 'undefined') {
            this._eventSubscribers[event] = [];
        }
        if (callback) {
            this._logger.debug('New subscriber on event: ' + event);
            this._eventSubscribers[event].push(callback);
        }
    }

    dispatch(event, context)
    {
        if (typeof this._eventSubscribers[event] !== 'undefined') {
            this._logger.debug('Event dispatching: ' + event);
            let callbacks = this._eventSubscribers[event];
            callbacks.forEach(
                function (callback) {
                    callback(context);
                }
            );
        }
    }

}

export default EventDispatcher;